import { replaceMacroEnumWithLabels } from "./modules/utils";

const GradingCommentTemplateTypePolicy = {
  GradingCommentTemplate: {
    fields: {
      comment: {
        read(existingComment) {
          return replaceMacroEnumWithLabels({
            comment: existingComment,
          });
        },
      },
    },
  },
};

export default GradingCommentTemplateTypePolicy;
